











import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';

const namespace: string = 'login';

@Component
export default class NavBar extends Vue {
  @Mutation('toggleMenu') private toggleMenu: () => void;

  public title(): string {
    return this.$route.meta.title;
  }
}
